import Base from '../base';
import { initializeSelect2 } from '../../packs/select2Utils';

export default class Index extends Base {
    load() {
        initializeSelect2();
        this.initializeDateFilter();
    }

    initializeDateFilter() {
        $('#date-filter-select').change(function() {
            if ($(this).val() === 'custom') {
                $('.date-range-inputs').show();
            } else {
                $('.date-range-inputs').hide();
                $('#stats-filter-form').submit(function() {
                    if ($('#date-filter-select').val() !== 'custom') {
                        $('#start_date, #end_date').remove();
                    }
                });
            }
        });

        if ($('#date-filter-select').val() !== 'custom') {
            $('#stats-filter-form').submit(function() {
                $('#start_date, #end_date').remove();
            });
        }
    }
}